import { NgModule } from "@angular/core";
import { DriverService } from "app/shared-model/services/driver.service";
import { LocationService } from "app/shared-model/services/location.service";
import { InsuredService } from "./services/insured.service";
import { VehiclesService } from "app/shared-model/services/vehicles.service";
import { PoliciesService } from "./services/policies.service";
import { ExportService } from "app/shared-model/services/export.service";
import { ImportService } from "./services/import.service";
import { ClaimService } from "./services/claim.service";
import { LetterService } from "./services/letter.service";
import { DeductibleService } from "./services/deductible.service";
import { MigratedSinesterService } from "./services/migratedsinester.service";
import { ImageService } from "./services/images.service";
import { MigratedClaimService } from "./services/migratedclaim.service";
import { InsuredNoteService } from "./services/InsuredNote.Service";
import { PrecargaSinDenunciaService } from "./services/precargaSinDenuncia.service";

@NgModule({
  imports: [],
  declarations: [],
  providers: [
    DriverService,
    LocationService,
    InsuredService,
    VehiclesService,
    PoliciesService,
    ExportService,
    ImportService,
    ClaimService,
    LetterService,
    DeductibleService,
    MigratedSinesterService,
    ImageService,
    MigratedClaimService,
    InsuredNoteService,
    PrecargaSinDenunciaService
  ],
})
export class SharedModelModule { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/shared-model.module.ts